export default __webpack_public_path__ + "static/media/cardplus.e9a7fa1c.png";